export const getImageDimensions = (count: number, ratio?: string, isMobile = false) => {
  const width = isMobile ? 375 : count > 1 ? 568 : 970;

  if (!ratio || ratio === 'auto') {
    // Current legacy crop proportions for fallback
    return count > 1 ? { width, height: isMobile ? 289 : 438 } : { width, height: isMobile ? 327 : 747 };
  }

  switch (ratio) {
    case 'square':
      return { width, height: width };
    case 'standard':
      return { width, height: Math.round((width * 3) / 4) };
    case 'portrait':
      return { width, height: Math.round((width * 3) / 2) };
    case 'portraitTall':
      return { width, height: Math.round((width * 16) / 9) };
    case 'wide':
      return { width, height: Math.round((width * 9) / 16) };
    case 'ultrawide':
      return { width, height: Math.round((width * 9) / 21) };
    default:
      return count > 1 ? { width, height: isMobile ? 289 : 438 } : { width, height: isMobile ? 327 : 747 };
  }
};

export const getAspectRatioClass = (ratio?: string, isMobile = false) => {
  const prefix = isMobile ? '' : 'md:';

  if (!ratio || ratio === 'auto') return `${prefix}aspect-auto`;

  switch (ratio) {
    case 'square':
      return `${prefix}aspect-square`;
    case 'standard':
      return `${prefix}aspect-[4/3]`;
    case 'portrait':
      return `${prefix}aspect-[2/3]`;
    case 'portraitTall':
      return `${prefix}aspect-[9/16]`;
    case 'wide':
      return `${prefix}aspect-video`;
    case 'ultrawide':
      return `${prefix}aspect-[21/9]`;
    default:
      return `${prefix}aspect-auto`;
  }
};
